/**
 * Whether a serialized GraphQL request body is the single `Whoami` operation -
 * the one response the offline flow caches in IndexedDB (see `sw.ts`).
 *
 * Deliberately narrow. `Whoami` is routed to `singleHttpLink` in
 * `ApolloClient.ts`, so its body is one JSON object; every batched operation
 * goes out through `BatchHttpLink` as a JSON *array*, which has no
 * `operationName` of its own and must not be mistaken for a session response.
 * If `Whoami` is ever moved off the single link, this returns false and the
 * offline session cache goes quietly empty - hence the tests.
 */
export default function isWhoamiRequestBody(
  body: BodyInit | null | undefined,
): body is string {
  if (typeof body !== 'string') {
    return false;
  }
  try {
    return JSON.parse(body)?.operationName === 'Whoami';
  } catch {
    // A body that isn't JSON is never the operation we're looking for.
    return false;
  }
}
